import React, { useState } from "react";
import "./BluePayNotice.css";

const stores = [
    { key: "google", name: "Google Play", href: "https://play.google.com/store/apps/details?id=cloud.blueparking.invitefriend" },
    { key: "apple", name: "App Store", href: "https://apps.apple.com/app/id6796329831" },
];

function getDeviceStore() {
    if (typeof navigator === "undefined") return null;
    const { userAgent, platform, maxTouchPoints } = navigator;
    if (/android/i.test(userAgent)) return stores[0];
    // iPadOS can identify itself as a desktop Mac.
    if (/iPhone|iPad|iPod/i.test(userAgent) || (platform === "MacIntel" && maxTouchPoints > 1)) {
        return stores[1];
    }
    return null;
}

function AppInstallBanner() {
    const [dismissed, setDismissed] = useState(false);
    const store = getDeviceStore();
    if (dismissed) return null;

    return (
        <aside className="app-install-banner" dir="rtl" aria-label="התקנת אפליקציית Blue PARC">
            <button className="app-install-banner__close" type="button" onClick={() => setDismissed(true)} aria-label="סגירת באנר ההתקנה">×</button>
            <img className="app-install-banner__icon" src={`${process.env.PUBLIC_URL}/blue-parc-brand-icon.png`} width="48" height="48" alt="" />
            <div className="app-install-banner__info">
                <strong dir="ltr">Blue PARC</strong>
                <span>{store ? store.name : "האפליקציה לתשלום חניה"}</span>
            </div>
            {store ? (
                <a className="app-install-banner__install" href={store.href} aria-label={`התקנת Blue PARC מ־${store.name}`}>התקן</a>
            ) : (
                <details className="app-install-banner__stores">
                    <summary className="app-install-banner__install">התקן</summary>
                    <nav className="app-install-banner__menu" aria-label="בחירת חנות אפליקציות">
                        {stores.map(option => <a key={option.key} href={option.href} dir="ltr">{option.name}</a>)}
                    </nav>
                </details>
            )}
        </aside>
    );
}

const App = () => {
    // VPOF is retired for every URL, including old payment and callback links.
    // Do not mount the previous flow: some pages submit transactions on mount.
    return (
        <>
        <AppInstallBanner />
        <main className="bluepay-notice" dir="rtl" aria-labelledby="bluepay-notice-title">
            {/* The campaign artwork has no store buttons. Text remains available to AT. */}
            <div className="bluepay-notice__accessible-copy">
                <p>Blue Parking — <bdi>Blue PARC</bdi></p>
                <h1 id="bluepay-notice-title">ההנחה מחכה לכם באפליקציה</h1>
                <p>מורידים, משלמים וחוסכים</p>
                <h2>וכל זה באפליקציה אחת</h2>
                <ul>
                    <li>מנוי יומי / חודשי</li>
                    <li>הזמנת חניה</li>
                    <li>השכרת החניה שלכם</li>
                    <li>ניווט לחניונים</li>
                    <li>מציאת הרכב</li>
                    <li>מחירים ותפוסה</li>
                    <li>שערים ומצלמות</li>
                    <li>הסדרת חניות עבר</li>
                </ul>
            </div>
            <img
                className="bluepay-notice__artwork"
                src={`${process.env.PUBLIC_URL}/blue-parc-campaign-editable-caption.png`}
                alt=""
                width="937"
                height="1679"
            />
            {/* Keep the supplied brand asset separate from the campaign artwork. */}
            <div className="bluepay-notice__brand-icon">
                <img src={`${process.env.PUBLIC_URL}/blue-parc-brand-icon.png`} width="512" height="512" alt="" />
            </div>
            <p className="bluepay-notice__launch-caption">
                כחול־לבן <span>•</span> בתהליך השקה
            </p>
        </main>
        </>
    );
};

export default App;
